<div class="bg-white rounded-xl shadow-sm flex flex-col border border-gray-200 h-full">
    <div class="flex-1 overflow-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
        <table class="w-full text-left border-separate border-spacing-0" [className]="width">
            <thead class="bg-[#374151] text-white sticky top-0 z-10 shadow-md">
                <tr>
                    @for (h of headers(); track h.key) {
                    <th class="p-[0.4rem] tracking-wider border-r border-gray-500 whitespace-nowrap fs-14
                        sticky top-0 bg-[#374151]" [style.zIndex]="h.fixed ? 50 : 1"
                        [style.left.px]="h.fixed ? h.left : null" [style.width.px]="h.width">
                        @if(h.key === 'select') {
                        <label class="p-checkbox-custom">
                            <input type="checkbox" [checked]="allSelected()"
                                (change)="onToggleSelectAll($event.target.checked)" />

                            <span class="p-checkbox-box-custom">
                                <svg viewBox="0 0 14 14" class="p-checkbox-icon-custom">
                                    <path
                                        d="M4.86199 11.5948C4.78717 11.5923 4.71366 11.5745 4.64596 11.5426C4.57826 11.5107 4.51779 11.4652 4.46827 11.4091L0.753985 7.69483C0.683167 7.64891 0.623706 7.58751 0.580092 7.51525C0.536478 7.44299 0.509851 7.36177 0.502221 7.27771C0.49459 7.19366 0.506156 7.10897 0.536046 7.03004C0.565935 6.95111 0.613367 6.88 0.674759 6.82208C0.736151 6.76416 0.8099 6.72095 0.890436 6.69571C0.970973 6.67046 1.05619 6.66385 1.13966 6.67635C1.22313 6.68886 1.30266 6.72017 1.37226 6.76792C1.44186 6.81567 1.4997 6.8786 1.54141 6.95197L4.86199 10.2503L12.6397 2.49483C12.7444 2.42694 12.8689 2.39617 12.9932 2.40745C13.1174 2.41873 13.2343 2.47141 13.3251 2.55705C13.4159 2.64268 13.4753 2.75632 13.4938 2.87973C13.5123 3.00315 13.4888 3.1292 13.4271 3.23768L5.2557 11.4091C5.20618 11.4652 5.14571 11.5107 5.07801 11.5426C5.01031 11.5745 4.9368 11.5923 4.86199 11.5948Z"
                                        fill="currentColor">
                                    </path>
                                </svg>
                            </span>
                        </label>
                        <!-- <p-checkbox [checked]="selectedAllUI" (onChange)="onToggleSelectAll($event.checked)"
                            [binary]="true">
                        </p-checkbox> -->

                        } @else {
                        <!-- <button (click)="h.sortable && sortBy(h.key)" [class.cursor-pointer]="h.sortable"
                            [class.cursor-default]="!h.sortable"
                            class="w-full flex items-center justify-center gap-2 text-left outline-none fs-14">
                            <span>{{ h.label | translate}}</span>
                            @if(h.sortable) {
                            <div class="flex flex-col">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                                    stroke-linejoin="round" class="transition-colors"
                                    [class.text-white]="sortColumn() === h.key && sortDirection() === 'asc'"
                                    [class.text-gray-500]="sortColumn() !== h.key || sortDirection() !== 'asc'">
                                    <path d="m18 15-6-6-6 6" />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                                    stroke-linejoin="round" class="-mt-1.5 transition-colors"
                                    [class.text-white]="sortColumn() === h.key && sortDirection() === 'desc'"
                                    [class.text-gray-500]="sortColumn() !== h.key || sortDirection() !== 'desc'">
                                    <path d="m6 9 6 6 6-6" />
                                </svg>
                            </div>
                            }
                        </button> -->
                        <button
                            class="w-full flex items-center justify-center gap-2 text-left outline-none fs-14 cursor-default">
                            <span>{{ h.label | translate}}</span>
                        </button>
                        }
                    </th>
                    }
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 bg-white">
                @if (paginatedData().length > 0) {
                @for (item of paginatedData(); track item[key()]) {
                <ng-container [ngTemplateOutlet]="rowTemplate()"
                    [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
                }
                } @else {
                <tr>
                    <td [colSpan]="headers().length" class="px-6 py-16 text-center">
                        <div class="flex flex-col items-center gap-2">
                            <div class="w-12 h-12 bg-gray-50 rounded-full flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <circle cx="11" cy="11" r="8" />
                                    <path d="m21 21-4.3-4.3" />
                                </svg>
                            </div>
                            <p>{{'SYSMESER0004' | translate}}</p>
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>

    @if (enablePagination() && data().length > 0) {
    <div class="p-[0.4rem] border-t border-gray-200 bg-gray-50 flex items-center justify-between shrink-0">
        <span class="fw-600">
            {{'REVENSTR0026' | translate : { curent: startIndex() + 1, totalCurent : displayEndIndex(),total:
            totalCnt()} }}
        </span>
        <div class="flex items-center gap-2">
            <button (click)="changePage('prev')" [disabled]="currentPage() === 1"
                class="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-300 bg-white text-gray-500 hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m15 18-6-6 6-6" />
                </svg>
            </button>
            <div class="hidden sm:flex gap-1">
                @for (page of pageNumbers(); track page) {
                @if (page !== '...') {
                <button (click)="changePage(page)" [disabled]="currentPage() === page"
                    class="w-8 h-8 flex items-center justify-center rounded-lg disabled:cursor-not-allowed  transition-all"
                    [class]="currentPage() === page
                                    ? 'bg-indigo-600 text-white shadow-sm'
                                    : 'bg-white text-gray-600 border border-gray-300 hover:bg-gray-50'">
                    {{ page }}
                </button>
                } @else {
                <span class="px-2 text-gray-400 flex items-center ">...</span>
                }
                }
            </div>
            <button (click)="changePage('next')" [disabled]="currentPage() === totalPages()"
                class="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-300 bg-white text-gray-500 hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m9 18 6-6-6-6" />
                </svg>
            </button>
        </div>
    </div>
    }
</div>